import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight, Ship, CalendarDays } from "lucide-react";

const PRIORITY = {
  high: { label: "High Priority", cls: "bg-red-50 text-red-700 border-red-200" },
  medium: { label: "Medium Priority", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  low: { label: "Low Priority", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const OpportunityCard = ({ opp }) => {
  const navigate = useNavigate();
  const p = PRIORITY[opp.priority] || PRIORITY.low;
  const isEvent = !!opp.event;
  const go = () => {
    const params = new URLSearchParams();
    if (opp.boat_id) params.set("boatId", opp.boat_id);
    if (opp.objective) params.set("objective", opp.objective);
    navigate(`/create-campaign?${params.toString()}`);
  };
  const btnLabel = isEvent ? `Create ${opp.event?.event_type || "Event"} Campaign` : "Create Campaign";
  return (
    <div className="bg-white rounded-2xl border border-border p-5 flex flex-col gap-3 card-hover" data-testid={`opportunity-${opp.type}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-navy/5 flex items-center justify-center shrink-0">
            {isEvent ? <CalendarDays className="w-4 h-4 text-navy" /> : <Ship className="w-4 h-4 text-navy" />}
          </div>
          <h3 className="font-serif font-bold text-navy truncate" data-testid="opportunity-title">{opp.title}</h3>
        </div>
        <span className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border shrink-0 ${p.cls}`} data-testid="opportunity-priority">{p.label}</span>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed" data-testid="opportunity-reason">{opp.reason}</p>
      <div className="text-sm"><span className="text-muted-foreground">Recommended: </span><span className="font-semibold text-navy">{opp.recommended_action}</span></div>
      <Button onClick={go} className="mt-auto gold-gradient text-navy font-bold gold-sheen" data-testid="opportunity-action">
        <Sparkles className="w-4 h-4 mr-1.5" /> {btnLabel} <ArrowRight className="w-4 h-4 ml-1.5" />
      </Button>
    </div>
  );
};

export default OpportunityCard;
